const moment = require('moment');

function onlyNumber(input, toInt = false) {
	// Handle null/undefined
	if (input === null || input === undefined) {
		return toInt ? 0 : '';
	}

	// Convert to string first
	const str = String(input);

	// Extract numbers
	const numbersOnly = str.replace(/[^0-9]/g, '');

	// Handle empty result
	if (!numbersOnly) {
		return toInt ? 0 : '';
	}

	// Return appropriate type
	return toInt ? Number(numbersOnly, 10) : numbersOnly;
}

function formatCurrency(number, withPrefix = null) {
	if (number) {
		let formattedNumber = number.toString().replace(/\D/g, '');

		// Remove leading zeros
		formattedNumber = formattedNumber.replace(/^0+/, '');

		// If the string is empty after removing zeros (was all zeros), return "0"
		if (formattedNumber === '') {
			formattedNumber = '0';
		}

		let rest = formattedNumber.length % 3;
		let currency = formattedNumber.substr(0, rest);
		let thousand = formattedNumber.substr(rest).match(/\d{3}/g);
		let separator;

		if (thousand) {
			separator = rest ? ',' : '';
			currency += separator + thousand.join(',');
		}

		if (withPrefix) {
			currency = `${withPrefix} ${currency}`;
		}

		return currency;
	} else {
		return '';
	}
}

function indonesianCalendar(date, withTime = false) {
	if (!date) {
		return '';
	}
	const options = {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	};

	if (withTime) {
		options.hour = '2-digit';
		options.minute = '2-digit';
	}
	const formatedDate = moment(date)
		.locale('id')
		.format(withTime ? 'DD MMMM YYYY HH:mm' : 'DD MMMM YYYY');
	return formatedDate;
}

function gerDurationInDays(start, end) {
	return Math.ceil((end - start) / (1000 * 60 * 60 * 24));
}

export { onlyNumber, formatCurrency, indonesianCalendar, gerDurationInDays };
